import type { IAuditAdminRepository } from '@yawi/domain';
import type {
    AuditFilters,
    AuditListResponse,
} from '@yawi/types';
import { getApiClient } from '../../http/apiClient';

/**
 * `GET admin/audit` (AdminAuditQueryDto). El backend solo expone el listado:
 * no hay detalle por id, export ni catálogos de actores/acciones.
 */
export class ApiAuditAdminRepository implements IAuditAdminRepository {
  private readonly basePath = 'v1/admin/audit';

  async list(
    filters?: AuditFilters,
    page: number = 1,
    limit: number = 20
  ): Promise<AuditListResponse> {
    const client = getApiClient();
    const params = new URLSearchParams({ page: String(page), limit: String(limit) });
    for (const [key, value] of Object.entries(filters ?? {})) {
      if (value) params.append(key, value);
    }
    return client.get<AuditListResponse>(`${this.basePath}?${params.toString()}`);
  }
}
